import ollieBlockingCycle from '../../../shared/assets/img/ollie-blocking-cycle.svg';
import { motion, Variants } from 'framer-motion';

interface OllieBlockingCycleProps {
    variants: Variants;
    textVariants: Variants;
    currentStep: string;
}

export const OllieBlockingCycle = ({ variants, textVariants, currentStep }: OllieBlockingCycleProps) => {
    return (
        <motion.div
            className="absolute left-1/2 -translate-x-1/2 top-[75px] z-20"
            variants={variants}
            animate={currentStep}>
            <motion.span
                className="absolute -top-6 left-1/2 -translate-x-1/2 text-sm font-semibold opacity-0"
                variants={textVariants}
                animate={currentStep}>
                obsessless
            </motion.span>
            <img src={ollieBlockingCycle} alt="Ollie Blocking Cycle" />
        </motion.div>
    );
};